import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cca203"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-sidebar" }
const _hoisted_2 = { class: "layout-main-container" }
const _hoisted_3 = { class: "layout-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout-mask" }, null, -1))

export function render(_ctx, _cache) {
  const _component_MenuBar = _resolveComponent("MenuBar")
  const _component_app_sidebar_menu = _resolveComponent("app-sidebar-menu")
  const _component_router_view = _resolveComponent("router-view")
  const _component_app_footer = _resolveComponent("app-footer")
  const _component_app_bottom_menu = _resolveComponent("app-bottom-menu")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-wrapper", _ctx.containerClass])
  }, [
    _createVNode(_component_MenuBar, {
      app_base_data: _ctx.app_base_data,
      menu_items: _ctx.getMenus
    }, null, 8, ["app_base_data", "menu_items"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_sidebar_menu, {
        app_base_data: _ctx.app_base_data,
        item_side_menu: _ctx.item_side_menu
      }, null, 8, ["app_base_data", "item_side_menu"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(_component_app_footer, { app_base_data: _ctx.app_base_data }, null, 8, ["app_base_data"]),
      (_ctx.isMobile && _ctx.getMenus.length > 0)
        ? (_openBlock(), _createBlock(_component_app_bottom_menu, {
            key: 0,
            app_base_data: _ctx.app_base_data,
            menu_items: _ctx.getMenus
          }, null, 8, ["app_base_data", "menu_items"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4
  ], 2))
}